<script>
import { marked } from 'marked';

export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        html() {
            if (this.value) {
                return marked(this.value, { breaks: true });
            }

            return '';
        },
    },
};
</script>

<template>
    <div class="markdown">
        <div v-html="html" />
    </div>
</template>

<style
    scoped
    lang="scss"
>
.markdown p:last-child {
    margin-bottom: 0;
}
</style>
